import { Col, Row, Form, Breadcrumb, Input, InputNumber, Select, Button, DatePicker, Popover, Tabs, Switch } from "antd";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { useEffect, useRef, useState } from "react";
import { CloseOutlined, CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { createBill, editBill } from "../../api/bills";
import { getSingleCurencyRate } from "../../api/exchangerate"
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import SelectDiscount from "../UI/DiscountType/discounttype";

const AddEditBills = () =>{
  const { state } = useLocation();
  const { paymentMethods, suppliers, warehouses, currencies, bill } = state;

  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString ? JSON.parse(mainCurrencyString) : null;
  
  const [selectedCurrency, setSelectedCurrency] = useState(1);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [open, setOpen] = useState(false);
  const [inputEnabled, setInputEnabled] = useState(bill?.isTaxable);
  const [isDiscountable, setDiscountable] = useState(bill?.isDiscountable);
  const [discount, setDiscount] = useState(bill?.discount ?? false);
  const [key, setKey] = useState("1");

  const { id } = useParams();
  const navigate = useNavigate();
  const [t] = useTranslation("common");
  const sessionId = useRef(localStorage.getItem("sessionId"));

  const currentDateTime = dayjs();
  const dateFormat = "MM/DD/YYYY";

  const isEdit = () => {
    return !!id;
  };

  const [form] = Form.useForm();
  const { TextArea } = Input;

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createBill" : "editBill",
    !isEdit()
      ? (bill: any) => createBill({ ...bill, sessionId: sessionId.current })
      : (bill: any) => editBill(id, { ...bill, sessionId: sessionId.current }),
    {
      onSuccess: (res) => {
        navigate("/bills");
      },
      onError: (err) => {
      },
    }
  );

  const HandleFinish = () => {
    const newBill = form.getFieldsValue();

    const selectedDate = form.getFieldValue("date");
    let selectedDateTime = dayjs(bill?.date).format("HH:mm:ss");
    const dateTime = !selectedDate.isSame(dayjs(bill?.date), "day");
    if (dateTime) {
      selectedDateTime = dayjs().format("HH:mm:ss");
    }
    newBill.date =
      dayjs(selectedDate).format("MM/DD/YYYY") + " " + selectedDateTime;

    if (selectedCurrency === mainCurrency?.id) {
      newBill.exchangeRate = 1;
    }

    const selectedDueDate = form.getFieldValue("dueDate");
    let selecteddueDateTime = dayjs(bill?.dueDate).format("HH:mm:ss");
    const dueDate = !selectedDueDate.isSame(dayjs(bill?.dueDate), "day");
    if (dueDate) {
      selecteddueDateTime = dayjs().format("HH:mm:ss");
    }
    newBill.dueDate =
      dayjs(selectedDueDate).format("MM/DD/YYYY") + " " + selecteddueDateTime;

    mutateCreateUpdate(newBill);
  };

   useEffect(() => {
    if (isEdit()) {
      form.setFieldsValue({
        invoiceNo: bill?.invoiceNo,
        warehouseId: bill?.warehouse?.id,
        supplierId: bill?.supplier?.id,
        paymentModeId: bill?.paymentMode?.id,
        notes: bill?.notes,
        date: dayjs(new Date(bill?.date)),
        dueDate: dayjs(new Date(bill?.dueDate)),
        currencyId: bill?.currency?.id,
        exchangeRate: bill?.exchangeRate,
        tax: bill?.tax,
        discount: bill?.discount,
        discountType: bill?.discountType,
      });
      if (mainCurrency?.id === bill?.currency?.id) {
        setSelectedCurrency(bill?.currency?.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleRadioChange = (checked: any) => {
    setInputEnabled(checked);
  };

  const handleChange = (checked: any) => {
    setDiscountable(checked)
  };
 
  const handleCurrencySelection = async (value: any) => {
    setSelectedCurrency(value);
    if (value === mainCurrency?.id) {
      setExchangeRate(1);
    } else {
      const rates = await getSingleCurencyRate(value);
      const newRate = rates?.data.cuRate[0].rate
      setExchangeRate(newRate)
    }
  };

  const onChange = (key: string) => {
    setKey(key);
  };

  const content = (record: any) => {
    return (
      <>
        <p style={{ fontSize: "16px" }}>{t("status")}</p>
        <p style={{ fontSize: "600" }}>
          {record ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("approved")}
        </p>
        <p style={{ color: "#A7A7A7" }}>
          {record ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("received")}
        </p>
        <p style={{ color: "#A7A7A7" }}>
          {record ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("paid")}
        </p>
        <p style={{ color: "#A7A7A7" }}>
          {!record ? (
            <CheckOutlined
              style={{ fontSize: "16px" }}
              className="check-mark"
            />
          ) : (
            <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
          )}
          {t("posted")}
        </p>
      </>
    );
  };

  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];

  return (
    <>
      <Row>
        <Col offset={1} span={22}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              { title: <Link to="/bills">{t("bills-list")}</Link> },
              {
                title: (
                  <> {isEdit() ? `${t("edit-bill")}` : `${t("add-bill")}`}</>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("general-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col
            offset={1}
            span={20}
            className="editTitle"
            style={{ marginTop: "10px" }}
          >
            <div style={{ display: "flex", alignItems: "start" }}>
              <span>{bill?.supplier?.name}</span>
              <Popover
                trigger="click"
                content={content(true)}
                placement="bottom"
              >
                <Button type="text" className="Button">
                  <InfoCircleOutlined
                    style={{
                      color: "#1677FF",
                      fontSize: "20px",
                    }}
                  />
                </Button>
              </Popover>
            </div>
          </Col>
        ) : (
          <Col offset={1} span={20} className="editTitle">
            {/* {t("add-bill")} */}
          </Col>
        )}
      </Row>
      <Row>
        <Col offset={1} span={22}>
          <Tabs className="ant-tab" defaultActiveKey="1" activeKey={key} items={items} onChange={onChange}/>
        </Col>
      </Row>
      <Form layout="vertical" form={form} onFinish={HandleFinish} id="billform" 
      initialValues={
        { warehouseId: warehouses?warehouses[0].value:null, 
          supplierId: suppliers?suppliers[0].value:null,
          paymentModeId: paymentMethods?paymentMethods[0].value:null,
          currencyId: currencies?currencies[0].value:null,
          date: currentDateTime,
          dueDate: currentDateTime,
          exchangeRate: exchangeRate
        }}>
        <Row style={{ minHeight: "60vh" }}>
          <Col span={6} offset={1}>
            <Form.Item name="invoiceNo" label={`${t("invoice-number")}`}>
              <Input maxLength={50} autoComplete="off" placeholder={`${t("enter-text")}`} data-testid="Invoice-number"/>
            </Form.Item>

            <Form.Item name="warehouseId" label={`${t("warehouse")}`} rules={[{required: true}]}>
              <Select showSearch={true} optionFilterProp="label" data-testid="warehouse" placeholder={`${t("select-warehouse")}`} options={warehouses}/>
            </Form.Item>

            <Form.Item name="supplierId" label={`${t("supplier")}`} rules={[{required: true}]}>
              <Select showSearch={true} optionFilterProp="label" data-testid="supplier" placeholder={`${t("select-supplier")}`} options={suppliers}/>
            </Form.Item>

            <Form.Item name="paymentModeId" label={`${t("payment-method")}`} rules={[{required: true}]}>
              <Select showSearch={true} optionFilterProp="label" data-testid="payment" placeholder={`${t("select-payement-method")}`} options={paymentMethods}/>
            </Form.Item>
          </Col>

          <Col offset={2} span={6}>
            <Form.Item name="date" label={`${t("date")}`} rules={[{required: true}]}>
              <DatePicker data-testid="date" placeholder={`${t("MM/DD/YYYY")}`} format={dateFormat} style={{ width: "100%" }}/>
            </Form.Item>

            <Form.Item name="dueDate" label={`${t("due-date")}`} rules={[{required: true}]}>
              <DatePicker data-testid="due-date" placeholder={`${t("MM/DD/YYYY")}`} format={dateFormat} style={{ width: "100%" }}/>
            </Form.Item>

            <Form.Item name="currencyId" label={`${t("currency")}`} rules={[{required: true}]}>
              <Select showSearch={true} optionFilterProp="label" data-testid="currency" placeholder={`${t("select-currency")}`} options={currencies} onChange={handleCurrencySelection}/>
            </Form.Item>

            <Form.Item name="exchangeRate" label={`${t("exchange-rate")}`} rules={[{required: selectedCurrency !== mainCurrency?.id}]}>
              <InputNumber value={exchangeRate} style={{ width: '100%' }} autoComplete="off" placeholder={`${t("enter-text")}`} max={999999.99} min={0.01} precision={2} data-testid="exchange" disabled={selectedCurrency === mainCurrency?.id}/>
            </Form.Item>
          </Col>

          <Col offset={2} span={6}>
            <Form.Item name="isTaxable" label={`${t("tax")}`}>
              <div style={{ display: 'flex', alignItems: 'center', gap: "20px" }}>
                <Switch defaultChecked={bill?.isTaxable} checkedChildren={`${t("yes")}`} unCheckedChildren={`${t("no")}`} onChange={handleRadioChange} style={{ width: '80px', height: "25px" }} />
                <Input autoComplete="off" placeholder={`${t("enter-text")}`} maxLength={10} data-testid="tax" disabled={!inputEnabled}/>
              </div>
            </Form.Item>

            <Form.Item name="isDiscountable" label={`${t("discount")}`}>
              <div  style={{ display: 'flex', alignItems: 'center', gap: "20px" }}>
                <div>
                  <Switch defaultChecked={isDiscountable} checkedChildren={`${t("yes")}`} unCheckedChildren={`${t("no")}`} onChange={handleChange} style={{ width: '4rem', height: "25px" }} />
                </div>
                  
                <div  style={{ display: 'flex', alignItems: 'center', gap: "20px", width:"100%" }}>
                  <SelectDiscount isDiscountable = {isDiscountable}/>
                  <Input maxLength={10} disabled={!isDiscountable}  autoComplete="off" placeholder={`${t("enter-text")}`}/>
                </div>                
              </div>
            </Form.Item>

            <Form.Item name="notes" label={`${t("notes")}`}>
              <TextArea className="scrollable-textarea" autoComplete="off" data-testid="note" placeholder={`${t("enter-text")}`} autoSize={{ minRows: 4, maxRows: 4 }}/>
            </Form.Item>                        
          </Col>
        </Row>
      </Form>
      <Row>
        <Col span={4} offset={1}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col offset={16} span={2} style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}>
          <Col style={{ display: "flex", justifyContent: "flex-end" }}>
            <AddEditButton disabled={false} data-testid="add-button" onClick={() => {setOpen(true);}} isLoading={""}/>
          </Col>
        </Col>
      </Row>
      <AddEditModal
        form="billform"
        open={open}
        setOpen={setOpen}
        name={<span>{bill?.exchangeRate}</span>}
        title={`${t("bill")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditBills;
